<template>
  <div class="salesman-selection">
    <el-button v-if="!selectedEmployee.id" plain size="mini" @click="selectSalesman">{{ $t('Select salesman') }}</el-button>
    <div v-if="selectedEmployee.id">
      <label class="el-form-item__label star">{{ $t('Exhibitor Employee') }}</label>
      <span
        >{{ selectedEmployee.name }}
        <el-button class="salesman-btn" type="text" size="mini" @click="selectSalesman">{{ $t('Select again') }}</el-button></span
      >
    </div>

    <el-dialog
      :title="$t('Employee List')"
      :visible.sync="salesmanDialogVisible"
      custom-class="salesman-dialog-with-exhibitor"
      :before-close="handleClose"
      append-to-body
      top="20vh"
    >
      <div class="member-list" v-if="employeeList.length === 0">
        {{$t('common.noData')}}
      </div>
      <div class="member-list"  v-if="employeeList.length > 0">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in employeeList" :key="index">
            <div class="member-item" @click="handleEmployeeClick(item)">
              <img class="item-avatar" :src="item.avatar || defImage('actor')" />
              <div class="item-name">{{ item.name }}</div>
              <div class="item=position">{{ item.position }}</div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getExhibitorEmployeeList } from '@/api/index'
export default {
  name: 'SalesmanSelection',

  props: {
    exhibitorId: {
      type: String
    },
    employeeId: {
      type: String
    }
  },

  data() {
    return {
      salesmanDialogVisible: false,
      employeeList: [],
      selectedEmployee: {},
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },

  // mounted() {

  //   console.log(this.exhibitorId)
  // },

  methods: {
    emptySeleledEmployee() {
      this.selectedEmployee = {}
    },
    handleClose() {
      this.salesmanDialogVisible = false
    },

    selectSalesman() {
      const loading = this.$loading()
      this.employeeList = []
      getExhibitorEmployeeList({
        exhibitorId: this.exhibitorId
      }).then(res => {
        if (res.data.data.list && res.data.data.list.length !== 0) {
          for (let i in res.data.data.list) {
            this.employeeList.push({
              id: res.data.data.list[i]['id'],
              name: res.data.data.list[i]['name'] || '',
              avatar: res.data.data.list[i]['headImage'] || '',
              position: res.data.data.list[i]['post'] || '',
              easemobAccount: res.data.data.list[i]['easemobAccount'] || ''
            })
          }
        }
        this.salesmanDialogVisible = true
        loading.close()
      })
    },

    handleEmployeeClick(item) {
      this.salesmanDialogVisible = false
      this.selectedEmployee = item
      this.$emit('update:employeeId', this.selectedEmployee.id)
    }
  }
}
</script>
<style lang="stylus">
.salesman-selection {
  .star {
    margin-right: 25px;
  }
  .star:before {
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
  .salesman-btn {
    margin-left 10px;
  }
}

.salesman-dialog-with-exhibitor {
  width: 700px;

  .el-dialog__header {
    background-color: $color-main;
    padding: 6px 20px;
    box-sizing: border-box;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__title {
    color: $color-white;
    font-size: 16px;
    line-height: 30px;
  }

  .el-dialog__headerbtn {
    top: 13px;
    &:hover {
      .el-dialog__close {
        color: $color-white;
        opacity: 1;
      }
    }
  }

  .el-dialog__close {
    color: $color-white;
  }

  .member-list {
    width: 600px;
    margin: 0 auto;
    padding: 50px 0;
  }

  .swiper-button-prev, .swiper-button-next {
    color: $color-black;
    outline: none;
    top: 56%;
  }

  .swiper-button-prev:after, .swiper-button-next:after {
    font-size: 20px;
  }

  .member-item {
    cursor: pointer;
    width: 172px;
    height: 206px;
    border-radius: 4px;
    box-shadow: 0px 5px 8px 2px $box-shadow2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    position: relative;
    margin: 20px 10px;
    &:hover {
      box-shadow 0 6px 10px 5px $box-shadow1, 0 8px 12px 2px $box-shadow2
    }
  }

  .member-item .item-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit cover
  }

  .iconchat {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: $color-main;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .chat-title__icon {
    color: $color-white;
    margin-right: 10px;
    cursor: pointer;
  }

  .chat-title__name {
    color: $color-white;
    margin-right: 10px;
    font-size: 14px;
    line-height: 30px;
  }

  .chat-title__avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-left: 30px;
    margin-right: 10px;
  }

  .el-dialog__backbtn {
    position: absolute;
    top: 13px;
    left: 20px;
    padding: 0;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 16px;
  }

  .el-dialog__backbtn i:hover {
    color: $color-main;
  }
}
</style>
